// src/App.jsx
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// ✅ Scroll-to-top on route change
import ScrollToTop from "./components/layout/ScrollToTop";

// Layout Components
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";

// Public Pages
import Home from "./pages/Home";
import WhoWeAre from "./pages/about/WhoWeAre";
import Values from "./pages/about/Values";
import MissionVision from "./pages/about/MissionVision";
import Team from "./pages/about/Team";
import Gallery from "./pages/about/Gallery"; // ✅ NEW
import WhatWeDo from "./pages/WhatWeDo";
import FocusAreaDetail from "./pages/what-we-do/FocusAreaDetail";
import Projects from "./pages/Projects";
import ProjectDetails from "./pages/ProjectDetails";
import GetInvolved from "./pages/GetInvolved";
import { BlogList, BlogPost } from "./pages/Blog";
import { EventsList, EventDetail } from "./pages/Events";
import Contact from "./pages/Contact";
import DonateNow from "./pages/DonateNow";
import DonationThankYou from "./pages/DonationThankYou";
import Tatl1000 from "./pages/Tatl1000";
import TatlStoryDetails from "./pages/TatlStoryDetails";

// Terms + Privacy
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminProtectedRoute from "./components/admin/AdminProtectedRoute";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProjects from "./pages/admin/AdminProjects";
import Posts from "./pages/admin/Posts";
import PostCreate from "./pages/admin/PostCreate";
import PostEdit from "./pages/admin/PostEdit";
import Comments from "./pages/admin/Comments";
import AdminTatlStories from "./pages/admin/AdminTatlStories";
import TatlStoryCreate from "./pages/admin/TatlStoryCreate";
import TatlStoryEdit from "./pages/admin/TatlStoryEdit";

// Admin Event Pages
import AdminEvents from "./pages/admin/AdminEvents";
import EventCreate from "./pages/admin/EventCreate";
import EventEdit from "./pages/admin/EventEdit";

// Admin pages for contact/get-involved/newsletter
import Contacts from "./pages/admin/Contacts";
import Volunteers from "./pages/admin/Volunteers";
import Partners from "./pages/admin/Partners";
import Donations from "./pages/admin/Donations";
import Newsletters from "./pages/admin/Newsletters";

// ✅ NEW: Admin Gallery
import AdminGallery from "./pages/admin/AdminGallery";
import AdminGalleryFolder from "./pages/admin/AdminGalleryFolder";

// Public Layout wrapper
const PublicLayout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* ✅ ensures every route opens at the top (except #hash links) */}
        <ScrollToTop />

        <Routes>
          {/* Public routes */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />

            <Route path="/about/who-we-are" element={<WhoWeAre />} />
            <Route path="/about/values" element={<Values />} />
            <Route path="/about/mission-vision" element={<MissionVision />} />
            <Route path="/about/team" element={<Team />} />
            <Route path="/about/gallery" element={<Gallery />} /> {/* ✅ NEW */}

            <Route path="/tatl1000" element={<Tatl1000 />} />
            <Route path="/tatl1000/:slug" element={<TatlStoryDetails />} />

            {/* What We Do */}
            <Route path="/what-we-do" element={<WhatWeDo />} />
            <Route path="/what-we-do/:slug" element={<FocusAreaDetail />} />

            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:slug" element={<ProjectDetails />} />

            <Route path="/get-involved" element={<GetInvolved />} />

            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />

            <Route path="/events" element={<EventsList />} />
            <Route path="/events/:id" element={<EventDetail />} />

            <Route path="/contact" element={<Contact />} />
            <Route path="/donate-now" element={<DonateNow />} />
            <Route path="/donation-thank-you" element={<DonationThankYou />} />

            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Route>

          {/* Admin auth */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />

          {/* Admin protected */}
          <Route element={<AdminProtectedRoute />}>
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/projects" element={<AdminProjects />} />

            <Route path="/admin/posts" element={<Posts />} />
            <Route path="/admin/posts/new" element={<PostCreate />} />
            <Route path="/admin/posts/:id/edit" element={<PostEdit />} />
            <Route path="/admin/comments" element={<Comments />} />

            {/* Events Admin */}
            <Route path="/admin/events" element={<AdminEvents />} />
            <Route path="/admin/events/new" element={<EventCreate />} />
            <Route path="/admin/events/:id/edit" element={<EventEdit />} />

            {/* Admin list pages */}
            <Route path="/admin/contacts" element={<Contacts />} />
            <Route path="/admin/volunteers" element={<Volunteers />} />
            <Route path="/admin/partners" element={<Partners />} />
            <Route path="/admin/donations" element={<Donations />} />
            <Route path="/admin/newsletters" element={<Newsletters />} />

            <Route path="/admin/tatl" element={<AdminTatlStories />} />
            <Route path="/admin/tatl/new" element={<TatlStoryCreate />} />
            <Route path="/admin/tatl/:id/edit" element={<TatlStoryEdit />} />

            {/* ✅ NEW: Gallery Admin */}
            <Route path="/admin/gallery" element={<AdminGallery />} />
            <Route path="/admin/gallery/:slug" element={<AdminGalleryFolder />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;